var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandMoreIcon = function SvgExpandMoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M10.01 14.513c-.421 0-.782-.18-1.023-.48L3.035 7.357c-.361-.481-.3-1.202.18-1.563.481-.361 1.143-.361 1.503.12l5.171 5.892c.06.06.12.06.24 0l5.172-5.892c.42-.481 1.082-.541 1.563-.12.481.42.541 1.082.12 1.563l-.06.06-5.892 6.674c-.24.24-.662.421-1.022.421z"
  })));
};
export { SvgExpandMoreIcon as ReactComponent };